"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useChangeLanguage = void 0;
const react_redux_1 = require("react-redux");
const slice_1 = require("./slice");
const useChangeLanguage = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const changeLanguage = (langCode) => {
        dispatch(slice_1.languagesProviderActions.setCurrentLanguageCode({
            langCode,
        }));
    };
    return { changeLanguage };
};
exports.useChangeLanguage = useChangeLanguage;
//# sourceMappingURL=useChangeLanguage.js.map